<app-header>
  <a class="logo-el" [routerLink]="'/'">
    <img src="/assets/picflow-icon.svg" alt="" width="32" height="32" />
    <span>Picflow</span>
  </a>
  <div class="spacer"></div>

  <div class="header-buttons" *onlyForScreens="['desktop']">
    <a
      [routerLink]="'/auth/login'"
      appButton
      name="login"
      location="unsubscribe-base-page"
      weight="bold"
      color="hard-simple"
      >Log in</a
    >
    <a
      [routerLink]="'/auth/signup'"
      appButton
      name="signup"
      location="unsubscribe-base-page"
      color="primary"
      weight="bold"
      >Sign up Free</a
    >
  </div>
</app-header>

<router-outlet></router-outlet>
